<template>
  <div class="table-box">
    <div
      style="display:flex;justify-content: flex-end;margin-bottom: 30px;margin-top: 15px;"
    >
      <el-button
        style="height:40px;"
        type="primary"
        @click="allReport"
        v-if="isMaster && showCumulativeBtn"
      >
        累计结算报告
      </el-button>
      <el-button
        style="height:40px;"
        type="primary"
        @click="customBi"
        v-if="hasBi && isMaster"
      >
        自定义数据报告
      </el-button>
    </div>
    <!--列表-->
    <div class>
      <el-table
        v-if="projectType !== 19"
        v-loading="loading"
        :data="tableData"
        border
        style="width: 100%"
        :stripe="true"
        :highlight-current-row="false"
      >
        <el-table-column type="index" label="序号" align="center" width="80" />
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="aspSubmitDt"
          label="提交日期"
        >
          <template slot-scope="scope">
            {{ dayjs(scope.row.aspSubmitDt).format('YYYY-MM-DD') }}
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="提交任务量"
          prop="taskSum"
        >
          <!-- <template slot-scope="{row}">{{row.finishSum?row.finishSum:'接收后显示'}}</template> -->
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="接收任务量"
          prop="receiveTaskSum"
        ></el-table-column>
        <!-- <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="实际完成任务量"
          prop="finishSum"
        >
          <template slot-scope="{row}">{{row.finishSum?row.finishSum:'接收后显示'}}</template>
        </el-table-column> -->
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="结算单价（税前）"
          v-if="!isAccess"
        >
          <template slot-scope="scope">
            {{ scope.row.price ? (scope.row.price / 100).toFixed(2) : 0 }}元
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="结算金额（税前）"
          v-if="!isAccess"
        >
          <template slot-scope="scope">
            {{
              scope.row.toCsoPrice
                ? (scope.row.toCsoPrice / 100).toFixed(2)
                : 0
            }}元
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="接收状态"
        >
          <template slot-scope="scope">
            {{ scope.row | transAuditStatus }}
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="电子结算单"
        >
          <template slot-scope="scope">
            {{ scope.row | transContract }}
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="税率"
        >
          <template slot-scope="scope">
            {{
              scope.row.contractScale
                ? (scope.row.contractScale / 100).toFixed(2)
                : 0
            }}%
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="数据包"
          v-if="isMaster"
        >
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="checkDataZip(scope)">
              查看
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200" align="center">
          <template slot-scope="scope">
            <div>
              <!-- <el-button
                type="text"
                size="small"
                @click="detail(scope)"
                :disabled="scope.row.csoStatus != 1"
              >数据报告</el-button> -->
              <el-button
                type="text"
                size="small"
                @click="accept(scope)"
                :disabled1="
                  scope.row.csoStatus != 1 || scope.row.industryConfirm != 0
                "
              >
                接收任务
              </el-button>
              <el-button
                type="text"
                size="small"
                @click="signContract(scope.row)"
                v-if="scope.row.signStatus !== 2"
                :disabled="
                  scope.row.industryConfirm === 0 ||
                    scope.row.signStatus !== 1 ||
                    scope.row.signType === 2 ||
                    scope.row.isSign === 1
                "
              >
                {{
                  scope.row.contractFrom === 1 && scope.row.signStatus !== 5
                    ? '发起'
                    : '签署'
                }}结算单
              </el-button>
              <el-button
                type="text"
                size="small"
                @click="checkRes(scope.row)"
                :disabled="scope.row.signStatus != 2"
                v-else
              >
                查看结算单
              </el-button>
              <el-button
                type="text"
                size="small"
                @click="download(scope.row)"
                :disabled="scope.row.signStatus != 2"
              >
                下载
              </el-button>
              <!-- <el-button
                v-if="[2,5,7,9,10,20].includes(projectType)"
                :disabled="judgeBaobiao(scope.row)"
                @click="generateCharts(scope.row)"
                type="text"
                size="small"
              >生成分析报表</el-button> -->
              <!-- <el-button
                type="text"
                size="small"
              >当期BI报表</el-button>
               <el-button
                type="text"
                size="small"
              >累计BI报表</el-button> -->
            </div>
          </template>
        </el-table-column>
      </el-table>
      <!-- 协定服务 -->
      <el-table
        v-else
        v-loading="loading"
        :data="tableData"
        border
        style="width: 100%"
        :stripe="true"
        :highlight-current-row="false"
      >
        <el-table-column type="index" label="序号" align="center" width="80" />
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          prop="aspSubmitDt"
          label="提交日期"
        >
          <template slot-scope="scope">
            {{ dayjs(scope.row.aspSubmitDt).format('YYYY-MM-DD') }}
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="实际完成任务量"
          prop="finishSum"
        >
          <template slot-scope="{ row }">
            {{ row.receiveTaskSum ? row.receiveTaskSum : '接收后显示' }}
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="结算金额（税前）"
        >
          <template slot-scope="{ row }">
            {{ row.toCsoPrice | moneyFixed }}
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="税率"
        >
          <template slot-scope="scope">
            {{ scope.row.contractScale ? scope.row.contractScale / 100 : 0 }}%
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="接收状态"
        >
          <template slot-scope="scope">
            {{ scope.row | transAuditStatus }}
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="电子结算单"
        >
          <template slot-scope="scope">
            {{ scope.row | transContract }}
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="数据包"
          v-if="isMaster"
        >
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="checkDataZip(scope)">
              查看
            </el-button>
          </template>
        </el-table-column>
        <el-table-column label="操作" width="200" align="center">
          <template slot-scope="scope">
            <div>
              <el-button type="text" size="small" @click="accept(scope)">
                接收任务
              </el-button>
              <el-button
                type="text"
                size="small"
                @click="signContract(scope.row)"
                v-if="scope.row.signStatus !== 2"
                :disabled="
                  scope.row.industryConfirm === 0 ||
                    scope.row.signStatus !== 1 ||
                    scope.row.isSign === 1 ||
                    scope.row.isNeedSeal === 0
                "
              >
                签署结算单
              </el-button>
              <el-button
                type="text"
                size="small"
                @click="checkRes(scope.row)"
                :disabled="scope.row.signStatus != 2"
                v-else
              >
                查看结算单
              </el-button>
              <el-button
                type="text"
                size="small"
                @click="download(scope.row)"
                :disabled="scope.row.signStatus != 2"
                v-if="downLoadBtnShow"
              >
                下载
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <YshTaskDialog
      v-if="showDialog"
      :rowData="rowData"
      @task-close="taskClose"
    />
    <acceptDetail
      :dialogVisible="acceptDetailShow"
      @done="acceptDetailShow = false"
    />
    <!-- this.makeSureEvent(_, scope,'<span>如需查看任务记录详情</span><br/>请点击查看详情按钮',
        {
          center: true,
          // title:'接收任务',
          dangerouslyUseHTMLString:true,
          confirmButtonText:'全部接收',
          cancelButtonText:'进入审核',
          callback:(action,instance,a,b,c)=>{
            if(action === 'cancel'){
              this.detail(scope)
            }else{
              receive.receiveTaskRecord({
                statementId:scope.row.statementId,
                isAll:1,
                auditGongyeStatus:2
              }).then(res=>{
                this.$message.success(res.data)
              })
            }
          }
        }
      ); -->
    <el-dialog
      title="接收任务"
      :visible.sync="confirmDialogVisible"
      width="30%"
    >
      <p>如需查看任务记录详情</p>
      <p>请点击进入审核按钮</p>
      <div slot="footer" style="text-align:center">
        <el-button @click="confirmList">进入审核</el-button>
        <el-button
          :disabled="tempScope.row.industryConfirm !== 0"
          type="primary"
          @click="confirmGet"
        >
          全部接收
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import dayjs from 'dayjs';
import { mapGetters } from 'vuex';

import {
  bingli,
  project,
  eContract,
  zsBingli,
  receive,
  biBase,
  receivReport
} from '@/api/ajax';
import { projectAllList } from '@/config/staticData';
import { pageInation } from '@/Mixin/listMixin';
import { initSearch } from '@/Mixin/initSearch';
import { makeSure } from '@/Mixin/makeSure';
import dicSelect from '@/components/Common/dicSelect.vue';
import YshTaskDialog from '@/components/Task/TaskDialog';
import { resolve } from 'url';
import OpenNewWin from '@/tools/openNewWin';
import { getStorage } from '@/tools/storage';
import checkDataZip from './components/checkDataZip.vue';
import acceptDetail from './components/AcceptDetail.vue';
import { CLIENT_RENEG_LIMIT } from 'tls';
import { createLogger } from 'vuex';

import createExtend from '@/components/createExtend';
import CustomBi from './components/CustomBi';
import DataDialog from './components/data-dialog';

let _arr = [];
projectAllList.filter((item, index) => {
  _arr.push(index + 1);
});
const _accessArr = [11, 12, 13, 14, 15]; // 市场准入系列不显示计划任务量和结算单价
export default {
  mixins: [pageInation, makeSure],
  props: {
    projectType: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      ruleForm: {}, // 用户信息
      showDialog: false,
      rowData: {},
      scopeData: {},
      tempScope: { row: {} },
      listFilter: e => {
        return e;
      },
      dialogVisible: false,
      confirmDialogVisible: false,
      acceptDetailShow: false
    };
  },
  components: {
    dicSelect,
    YshTaskDialog,
    acceptDetail
  },
  computed: {
    ...mapGetters(['isMaster']),
    homeProject() {
      return this.$store.state.homeProject;
    },
    // 5调研问卷 20可配置 21数字问卷 19协定服务  6数字专区 17数字拜访
    allScene() {
      return [5, 6, 17, 19, 20, 21].includes(this.projectType);
    },
    hasBi() {
      return [2, 5, 6, 7, 9, 10, 20, 21].includes(this.projectType);
    },
    // v3版bi场景，没有累计，老BI场景还是有累计
    showCumulativeBtn() {
      return ![5, 20].includes(this.projectType);
    },
    searchQuery() {
      return {
        projectId: this.$route.query.id
      };
    },
    getList() {
      // const obj = {
      //   5: project.dcwjIndustryList,
      //   7: project.yshDcwjIndustryList,
      //   8: bingli.bingliProjectTask,
      //   18: zsBingli.bingliProjectTask
      // };
      // return obj[this.projectType] || project.projectIndustryList;
      return receive.listStatement;
    },
    submitAjax() {
      //接收的接口
      const ajaxs = {
        8: bingli.yshIndustryConfirm,
        5: project.dcwjIndustryConfirm,
        7: project.yshIndustryConfirm,
        18: zsBingli.yshIndustryConfirm
      };
      return ajaxs[this.projectType] || project.industryConfirm;
    },
    isAccess() {
      return _accessArr.includes(this.projectType);
    }
  },
  methods: {
    dayjs,
    allReport() {
      let fn = null;
      if ([5, 20].includes(+this.projectType)) {
        fn = biBase.getFenpeiIdListV2;
      } else {
        fn = biBase.getFenpeiIdList;
      }
      fn({
        projectId: this.$route.query.id,
        startTime: 0,
        endTime: 0,
        type: 2
      }).then(res => {
        const fenpeiIds = res.data.data.map(item => item.id);
        createExtend(DataDialog, {
          autoCheckList: [2, 8],
          biInfoIdFromList: fenpeiIds[0],
          statementId: fenpeiIds,
          isAll: true,
          currentBiId: null
        });
      });
    },
    customBi() {
      createExtend(CustomBi);
    },
    async checkDataZip(scope) {
      let data, res;
      try {
        res = await receivReport.checkAcceptanceAndAudit({
          projectId: this.$route.query.id,
          fenPeiId: scope.row.statementId
        });
        data = res.data.data;
      } catch (err) {
        console.log(err.message);
        data = {};
      }
      createExtend(DataDialog, {
        autoCheckList: [1, 7],
        allScene: this.allScene,
        biInfoIdFromList: scope.row.currentBiId,
        currentBiId: scope.row.currentBiId,
        statementId: scope.row.statementId,
        ...data
      });
    },
    judgeBaobiao(row) {
      //判断是否可以生成分析报表
      return row.csoStatus === 0 || row.biSwitch === '1';
    },
    chartsType(type) {
      const obj = {
        2: 'otc',
        5: 'dcwj',
        7: 'dcwj',
        9: 'gradeHospital',
        10: 'jcyljg',
        20: 'makeScene'
      };
      return obj[type];
    },
    generateCharts(row) {
      //生成分析报表
      window.open(
        this.$router.resolve({
          name: 'bi',
          query: {
            projectId: this.$route.query.id,
            taskDt: row.taskMonth,
            serviceType: this.chartsType(this.projectType),
            type: this.projectType === 5 ? 1 : 2 // 问卷中使用（1助手 2医生汇）
          }
        }).href,
        '_blank'
      );
    },
    download(row) {
      //下载电子合同
      const arr = _arr;
      this.$downloadFile(
        `${eContract.downloadContractUrl}?id=${row.statementId}&signingId=${
          row.signingId
        }&type=${arr.includes(this.projectType) ? 1 : 2}`,
        true
      );
    },
    signContract(row) {
      //签约
      let win = new OpenNewWin();
      win.createWin();
      const arr = _arr;
      if (arr.includes(this.projectType)) {
        receive
          .signStatement({
            statementId: row.statementId,
            signType: row.signType
          })
          .then(res => {
            win.setUrl(res.data.data);
            this.$confirm(
              '请在新打开的页面完成签约，签约成功请点击完成',
              '提示',
              {
                confirmButtonText: '完成',
                cancelButtonText: '取消',
                type: 'warning'
              }
            )
              .then(() => {
                this.initWatchRouteChange();
              })
              .catch(() => {
                this.$message({
                  type: 'info',
                  message: '已取消'
                });
                this.initWatchRouteChange();
              });
          });
      } else {
        eContract
          .firstYshSign({ id: row.id, signingId: row.signingId })
          .then(res => {
            win.setUrl(res.data.data.signUrl);
            this.$confirm(
              '请在新打开的页面完成签约，签约成功请点击完成',
              '提示',
              {
                confirmButtonText: '完成',
                cancelButtonText: '取消',
                type: 'warning'
              }
            )
              .then(() => {
                this.initWatchRouteChange();
              })
              .catch(() => {
                this.$message({
                  type: 'info',
                  message: '已取消'
                });
                this.initWatchRouteChange();
              });
          });
      }
    },
    confirmList() {
      let scope = this.tempScope;
      this.detail(scope);
      this.confirmDialogVisible = false;
    },
    confirmGet() {
      let scope = this.tempScope;
      receive
        .receiveTaskRecord({
          statementId: scope.row.statementId,
          isAll: 1,
          auditGongyeStatus: 2
        })
        .then(res => {
          this.$message.success(res.data);
          this.confirmDialogVisible = false;
          this.searchEvent();
        });
    },
    checkRes(row) {
      //查看电子合同
      let win = new OpenNewWin();
      win.createWin();
      const arr = _arr;
      const { statementId, signingId } = row;
      if (arr.includes(this.projectType)) {
        //医学助手联盟
        eContract
          .lookContract({ id: statementId, type: 1, signingId })
          .then(res => {
            win.setUrl(res.data.data);
          });
      } else {
        //医生汇联盟
        eContract
          .lookContract({ id: statementId, type: 2, signingId })
          .then(res => {
            win.setUrl(res.data.data);
          });
      }
    },
    detail(scope) {
      // 如果甲乙都确认了则可使用个人BI导出功能 industryConfirm:1为甲方确认 csoStatus:1为乙方确认
      localStorage.setItem(
        'exportPersonalBiDisabled',
        !(scope.row.industryConfirm && scope.row.csoStatus) ||
          scope.row.biSwitch === '1'
      );
      //点击详情
      if (scope.row.authType) {
        localStorage.setItem('authType', scope.row.authType);
      }
      // let projectId = scope.row.projectId;
      let statementId = scope.row.statementId || 1;
      let month = scope.row.taskMonth;
      let projectId = this.$route.query.id;
      let { row } = scope;
      localStorage.setItem('authType', row.authType);
      const type1 = {
        projectId,
        month,
        statementId,
        id: projectId,
        taskMonth: month,
        signType: row.signType,
        isNeedSeal: row.isNeedSeal,
        questionnaireAnswerId: projectId
      };
      const type2 = {
        projectId,
        month,
        statementId,
        id: projectId,
        questionnaireAnswerId: projectId,
        taskMonth: month,
        isNeedSeal: row.isNeedSeal,
        signType: row.signType
      };
      let obj = {};
      projectAllList.filter((item, index) => {
        obj[index + 1] = {
          name: item.filePath + 'RecordList',
          query: [5, 7].includes(index + 1) ? type2 : type1
        };
      });
      const pathInfo = obj[this.homeProject.projectType];
      this.SET_PAGENUM(1);
      localStorage.removeItem('recordsearchQuery');
      this.$router.push({
        name: pathInfo.name,
        query: pathInfo.query
      });
    },
    accept(scope) {
      //点击接收
      this.tempScope = scope;

      let signingId;
      let { $index, row } = scope;
      let delEvent = scope => {
        this.submitAjax({
          id: row.id
        })
          .then(res => {
            signingId = res.data.data.singingId;
            this.$notify({
              title: '成功',
              message: '接收成功',
              type: 'success'
            });
            this.initWatchRouteChange();
            if (scope.row.isTool != 1) {
              this.makeSureEvent(
                conTractEvent,
                row,
                '是否确认签署线上电子结算单'
              );
            }
          })
          .catch(err => {
            console.error(err);
          });
      };
      let conTractEvent = () => {
        let win = new OpenNewWin();
        win.createWin();
        const arr = _arr;
        if (arr.includes(this.projectType)) {
          eContract.firstSign({ id: row.id, signingId }).then(res => {
            win.setUrl(res.data.data.signUrl);
          });
          this.$confirm(
            '请在新打开的页面完成签约，签约成功请点击完成',
            '提示',
            {
              confirmButtonText: '完成',
              cancelButtonText: '取消',
              type: 'warning'
            }
          )
            .then(() => {
              this.initWatchRouteChange();
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: '已取消'
              });
              this.initWatchRouteChange();
            });
        } else {
          eContract.firstYshSign({ id, signingId }).then(res => {
            win.setUrl(res.data.data.signUrl);
          });
          this.$confirm(
            '请在新打开的页面完成签约，签约成功请点击完成',
            '提示',
            {
              confirmButtonText: '完成',
              cancelButtonText: '取消',
              type: 'warning'
            }
          )
            .then(() => {
              this.initWatchRouteChange();
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: '已取消'
              });
              this.initWatchRouteChange();
            });
        }
      };
      this.confirmDialogVisible = true;
    },
    taskClose() {
      this.showDialog = false;
    }
  },
  filters: {
    transJiesuan(row) {
      return ((row.finishSum * row.price) / 100).toFixed(2);
    },
    transAuditStatus(val) {
      if (val.csoStatus == 0) {
        return '乙方未提交';
      } else {
        if (val.industryConfirm == 0) {
          return '未接收';
        } else {
          return '已接收';
        }
      }
    },
    transSign() {},
    transContract(row) {
      // if(row.isNeedSeal === 0){
      //   if(row.toBeSignedByTheServiceProvider === 1){
      //     return '已签署'
      //   }else{
      //     return '待服务商签署'
      //   }
      // }
      if (row.signStatus === '-') {
        return '-';
      }
      if (row.signStatus == 0) {
        return '无';
      } else {
        if (row.signStatus == 1) {
          return '待我签';
        } else if (row.signStatus == 2) {
          return '已签署';
        } else if (row.signStatus == 3) {
          return '签约失败';
        } else if (row.signStatus == 4) {
          return '待他签';
        } else if (row.signStatus == 5) {
          return '线下签署';
        } else if (row.signStatus == 6) {
          return '待确认';
        }
      }
    }
  },
  created() {
    //只在协定服务并且是活动形式的任务展示
    const {
      fileUpSource,
      fileUpMode,
      projectType
    } = this.$store.state.homeProject;
    const isEntry = [+fileUpSource, +fileUpMode].join(',');
    this.downLoadBtnShow = !(
      ['1,1', '3,1'].includes(isEntry) && projectType === 19
    );
  }
};
</script>
